<template>
  <div class="tags-view-container">
    <div class="tags-wrapper">
      <span
        v-for="tag in visitedViews"
        :key="tag.fullPath"
        class="tag-item"
        :class="{ active: isActive(tag) }"
        @click="go(tag)"
      >
        {{ tag.title }}
        <i
          v-if="tag.name !== 'home'"
          class="el-icon-close tag-close"
          @click.stop="closeTag(tag)"
        />
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "TagsView",
  computed: {
    visitedViews() {
      return (this.$store && this.$store.state.tagsView) ? this.$store.state.tagsView.visitedViews : [];
    },
  },
  watch: {
    $route() {
      this.addTag();
    },
  },
  mounted() {
    this.addTag();
  },
  methods: {
    isActive(route) {
      return route.fullPath === this.$route.fullPath;
    },
    addTag() {
      if (!this.$route.meta.title) return;
      if (this.$store && this.$store.dispatch) {
        this.$store.dispatch("tagsView/addView", this.$route);
      }
    },
    go(tag) {
      this.$router.push(tag.fullPath);
    },
    closeTag(tag) {
      if (this.$store && this.$store.dispatch) {
        this.$store.dispatch("tagsView/delView", tag).then(() => {
          if (this.isActive(tag)) {
            const last = this.visitedViews[this.visitedViews.length - 1];
            if (last) this.$router.push(last.fullPath);
          }
        });
      }
    },
  },
};
</script>

<style scoped>
/* 标签页容器 */
.tags-view-container {
  height: 100%;
  line-height: 100%;
  background: transparent;
  border: none;
  padding: 0;
  box-sizing: border-box;
  width: 100%;

}

/* 标签外层容器 - 核心：加overflow-x auto */
.tags-wrapper {
  display: flex;
  align-items: center;
  height: 100%;
  gap: 8px;
  flex-wrap: nowrap;
  overflow-x: auto; /* 标签过多时横向滚动 */
  overflow-y: hidden;
  padding: 0 5px;
  width: 100%;
  box-sizing: border-box;
}

/* 隐藏滚动条（美观） */
.tags-wrapper::-webkit-scrollbar {
  height: 4px;
}
.tags-wrapper::-webkit-scrollbar-thumb {
  background: #ddd;
  border-radius: 2px;
}
.tags-wrapper::-webkit-scrollbar-track {
  background: transparent;
}

/* 单个标签样式 */
.tag-item {
  padding: 0 12px;
  height: 30px;
  line-height: 30px;
  background: #f5f7fa;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  color: #333;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  justify-content: center;	
  transition: all 0.2s;
}

/* 激活的标签 */
.tag-item.active {
  background: #409eff;
  color: #fff;
    font-size: 18px;
	font-weight: bold;
}

/* hover效果 */
.tag-item:hover:not(.active) {
  background: #e8f4ff;
}

/* 关闭按钮 */
.tag-close {
  font-size: 11px;
  margin-left: 6px;
  opacity: 0.8;
}
.tag-close:hover {
  opacity: 1;
}
</style>